import http from '@/biz/http.mjs'

export default {

    //publish: ({pkid}) => http.post('/releaseDepPs', {ids: [pkid]}),
    read: ({pkid}) => http.get('/oneDepPs', {pkid}),
    readList: (args) => http.get('/listDepPsByMap', args),
    //revise: ({pkid}) => http.post('/reviseDepPs', [pkid]),
}
